import { render, staticRenderFns } from "./DraftReturKirimInvent.vue?vue&type=template&id=2cc58a9c&"
import script from "./DraftReturKirimInvent.vue?vue&type=script&lang=js&"
export * from "./DraftReturKirimInvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports